import { useState, useRef } from "react";
import "./styles.css";

const wordsList = ["sentence", "Try", "a", "to", "make"];

const App = () => {
  const [destinationWords, setDestinationWords] = useState<string[]>([]);
  const [originWords, setOriginWords] = useState<string[]>(wordsList);
  const isAnimating = useRef(false);

  const flip = (
    wordElement: HTMLElement,
    first: DOMRect,
    last: DOMRect,
    callback: () => void
  ) => {
    const invertX = first.left - last.left;
    const invertY = first.top - last.top;

    const animation = wordElement.animate(
      [
        {
          transform: `translate(${invertX}px, ${invertY}px) scale(1)`,
          opacity: 1,
        },
        { transform: "translate(0, 0) scale(1)", opacity: 1 },
      ],
      { duration: 300, easing: "ease-out" }
    );

    animation.onfinish = () => {
      isAnimating.current = false;
      callback();
    };
  };

  const move = (word: string) => {
    if (isAnimating.current) return;
    isAnimating.current = true;

    const wordElement = document.querySelector(
      `[data-word='${word}']`
    ) as HTMLElement;
    const first = wordElement.getBoundingClientRect();

    setOriginWords((prev) => prev.filter((w) => w !== word));
    setDestinationWords((prev) => [...prev, word]);

    setTimeout(() => {
      const last = wordElement.getBoundingClientRect();
      flip(wordElement, first, last, () => {});
    }, 0);
  };

  const putback = (word: string) => {
    if (isAnimating.current) return;
    isAnimating.current = true;

    const wordElement = document.querySelector(
      `[data-word='${word}']`
    ) as HTMLElement;
    const first = wordElement.getBoundingClientRect();

    setDestinationWords((prev) => prev.filter((w) => w !== word));
    setOriginWords((prev) => {
      const newOrigin = [...prev, word];
      return wordsList.filter((w) => newOrigin.includes(w));
    });

    setTimeout(() => {
      const last = wordElement.getBoundingClientRect();
      flip(wordElement, first, last, () => {});
    }, 0);
  };

  return (
    <div className="words">
      <div className="destination">
        {destinationWords.map((word) => (
          <button
            key={word}
            className="word"
            data-word={word}
            onClick={() => putback(word)}
          >
            {word}
          </button>
        ))}
      </div>
      <div className="origin">
        {originWords.map((word) => (
          <div className="container" key={word}>
            <button
              className="word"
              data-word={word}
              onClick={() => move(word)}
            >
              {word}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default App;
